import {
  AtsGetCvBulkUploadsDocument,
  CreateAtsCvBulkUploadDocument,
  CreateAtsCvBulkUploadMutation,
  CreateAtsCvBulkUploadMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAtsCvBulkUpload = () => {
  const [create, { loading }] = useMutation(CreateAtsCvBulkUploadDocument, {
    extractorFn: (data: CreateAtsCvBulkUploadMutation) => data.atsMutations.createAtsCvBulkUpload,
    refetchQueries: [AtsGetCvBulkUploadsDocument],
  })

  return {
    loading,
    create(variables: CreateAtsCvBulkUploadMutationVariables) {
      return create({
        variables,
      })
    },
  }
}
